/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import styles from "./Styles.module.scss";
import {
  Breadcrumbs,
  Container,
  Grid,
  Link as BCLink,
  Box,
  Pagination,
} from "@mui/material";
import { NavigateNext } from "@mui/icons-material";
import axios from "../../axios";
import CategoriesTable from "../../components/Categories/CategoriesTable";
import SearchBox from "../../components/Navbar/SearchBox";
import { useTranslation } from "react-i18next";

const Categories = () => {
  const [categories, setCategories] = useState(null);
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      setCategories(null);
      fetch();
    }, 500);

    return () => clearTimeout(timer);
  }, [searchValue]);

  const fetch = () => {
    fetchCategories().then(function (res) {
      setCategories(res);
    });
  };

  const fetchCategories = async (page) => {
    return await new Promise(function (resolve, reject) {
      axios
        .get("/categories?page=" + (page ?? 0) + "&search=" + searchValue)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch(reject);
    });
  };

  const refresh = (event, page = null) => {
    setCategories(null);
    fetchCategories(page).then(function (res) {
      setCategories(res);
    });
  };

  const { t } = useTranslation();

  return (
    <div>
      <Container sx={{ pb: "1rem" }}>
        <div role="presentation">
          <Breadcrumbs
            aria-label="breadcrumb"
            separator={<NavigateNext fontSize="small" />}
            sx={{ p: "14px 0" }}
          >
            <BCLink
              className={styles.brdHov}
              underline="none"
              color="inherit"
              href="/"
              fontSize={"14px"}
            >
              {t("Home")}
            </BCLink>
            {/* <BCLink
              className={styles.brdHov}
              underline="none"
              color="inherit"
              href="/admin"
              fontSize={"14px"}
            >
              Admin
            </BCLink> */}
            <BCLink
              underline="none"
              color="text.primary"
              href="/store/categories"
              aria-current="page"
              fontSize={"14px"}
            >
              {t("Categories")}
            </BCLink>
          </Breadcrumbs>
        </div>
        <Grid container item spacing={2} sx={{ justifyContent: "center" }}>
          <Box
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-end",
            }}
          >
            <SearchBox
              searchValue={searchValue}
              setSearchValue={setSearchValue}
              placeholder={t("Search categories")}
              extraStyle={{ margin: "0px 0px 20px 0px" }}
              navigateOnEnter={null}
            />
          </Box>
          <Grid container item>
            {/* {accounts == null ? (
              <Loading />
            ) : (
              <> */}
            <CategoriesTable data={categories} searchValue={searchValue} />
            <Container
              sx={{
                marginTop: 2,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Pagination
                count={categories?.last_page || 0}
                page={categories?.current_page || 0}
                onChange={refresh}
              />
            </Container>
            {/* </> */}
            {/* )} */}
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default React.memo(Categories);
